
// Import test scripts
require('../../shared/modules/components/button-group/tests/js-view-renderer')
require('../../shared/modules/components/steps/tests/js-view-renderer')

// widgets
require('../../shared/modules/widgets/booking-car-rental/tests/js-view-renderer')
